
/**
 * 현재 사용자와 프로젝트 간의 상호작용 정보
 */
export type ProjectResponseUserInteraction = {
  /** 현재 사용자가 프로젝트 소유자인지 여부 */
  isOwnedByCurrentUser?: boolean;
  /** 현재 사용자가 좋아요를 눌렀는지 여부 */
  likedByCurrentUser?: boolean;
};
